export default __webpack_public_path__ + "static/media/No-Jobs.6edd4003.png";